import { Post, Get, Put, Delete } from "@/utils";
import { ApiPath, UserRoles } from "@/enums";

export default {
  namespaced: true,
  actions: {
    //TODO: Transfer to Other services (Organisation service)
    // addToAgencyQueue({}, agencyApplication) {
    //   return axios
    //     .post(
    //       `${process.env.VUE_APP_API_BASE_URI}agency/addtoagencyaueue`,
    //       agencyApplication
    //     )
    //     .then((res) => {
    //       return res;
    //     })
    //     .catch((res) => {
    //       const errors = res.response;
    //       throw errors;
    //     });
    // },
    // getAgencyApplication({}, registration) {
    //   return axios
    //     .post(
    //       `${process.env.VUE_APP_API_BASE_URI}agency/getagencyapplication`,
    //       registration
    //     )
    //     .then((res) => {
    //       return res;
    //     })
    //     .catch((res) => {
    //       const errors = res.response;
    //       throw errors;
    //     });
    // },

    async getReferralsByJobSeeker({ }) {
      const { data: referralsByJobSeeker } = await Get(
        `${ApiPath.Referrals}/getreferralsbyjobseeker`,
      );
      return referralsByJobSeeker;
    },
    async saveReferral({ }, body) {
      const { data: referralsByJobSeeker } = await Post(
        `${ApiPath.Referrals}/createreferral`,
        body
      );
      return referralsByJobSeeker;
    },
    async updateReferral({ }, body) {
      const { data: referralsByJobSeeker } = await Put(
        `${ApiPath.Referrals}/updatereferral`,
        body
      );
      return referralsByJobSeeker;
    },
  },
};
